import apiClient from "../ApiClient";
import AuthClient from "../../api/AuthClient";
import {
  CLEAR_AUTH_STATE,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  REFRESH_TOKEN,
  REGENERATE_QR_CODE,
  REGISTER_SUCCESS,
  SEND_OTP_FAILURE,
  SEND_OTP_REQUEST,
  SEND_OTP_SUCCESS,
  SET_USER_LOCATION,
  SIGNING_UP,
} from "./authActionTypes";

// set the actions

// 1. login
export const clearAuthState = () => {
  return {
    type: CLEAR_AUTH_STATE,
  };
};

export const regenerateQrCodeState = (qrDocument) => {
  return {
    type: REGENERATE_QR_CODE,
    payload: qrDocument,
  };
};

// 2. set and store the user info in case of success
export const loginSuccess = (userInfo) => {
  return {
    type: LOGIN_SUCCESS,
    payload: userInfo,
  };
};

// set the error message in case of an error
export const loginFailure = (error) => {
  return {
    type: LOGIN_FAILURE,
    payload: error,
  };
};

// Registration of the user
export const toggleSigningUp = (status) => {
  return {
    type: SIGNING_UP,
    payload: status,
  };
};
// incase the registration was successful
export const signupSuccess = (user) => {
  return {
    type: REGISTER_SUCCESS,
    payload: user,
  };
};

export const logoutRequest = () => {
  return {
    type: LOGOUT_REQUEST,
  };
};
// set and store the success message in case of logout success
export const logoutSuccess = (msg) => {
  return {
    type: LOGOUT_SUCCESS,
    payload: msg,
  };
};

// set and store the error message in case of logout failure
export const logoutFailure = (error) => {
  return {
    type: LOGOUT_FAILURE,
    payload: error,
  };
};

// send  OTP
export const otpRequest = () => {
  return {
    type: SEND_OTP_REQUEST,
  };
};
// set and store the success message in case of logout success
export const otpRequestSuccess = (msg) => {
  return {
    type: SEND_OTP_SUCCESS,
    payload: msg,
  };
};

// set and store the error message in case of logout failure
export const otpRequestFailure = (error) => {
  return {
    type: SEND_OTP_FAILURE,
    payload: error,
  };
};

// refresh token
export const refreshToken = () => {
  return {
    type: REFRESH_TOKEN,
  };
};

export const setUserLocation = (data) => {
  return {
    type: SET_USER_LOCATION,
    payload: data,
  };
};

// ----------------------- send to reducer -----------------

export function setUserLocationAction(data) {
  return function action(dispatch) {
    dispatch(setUserLocation(data));
  };
}

export function regenerateQrCode() {
  return function action(dispatch) {
    return AuthClient.regenerateQrCode()
      .then((response) => {
        if (response.status === 200) {
          const { data } = response.data;
          dispatch(regenerateQrCodeState(data));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

// login using axios

export function login(data) {
  return function action(dispatch) {
    dispatch(clearAuthState());

    return AuthClient.login(data)
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          dispatch(loginSuccess(response));
          return true;
        }
      })
      .catch((error) => {
        // console.log(error.response);
        if (error.response.status === 401) {
          dispatch(logoutSuccess("Failed to log you in. Retry."));
        }
        return false;
      });
  };
}

export function signUpAction(data) {
  return function action(dispatch) {
    dispatch(clearAuthState());

    return AuthClient.signup(data)
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          dispatch(signupSuccess(response.data));
          return { status: true, data: response.data };
        }
      })
      .catch((error) => {
        console.log(error.response);
        return { status: false, data: error.response.data.message };
      });
  };
}

// logout function
export function logoutRequestAction() {
  return function action(dispatch) {
    dispatch(logoutRequest());
    return AuthClient.logout()
      .then((response) => {
        if (response.status < 205) {
          dispatch(logoutSuccess("Logged out successfully"));
          // initializeToken();
          return true;
        } else {
          dispatch(logoutFailure("Operation failed"));
          return false;
        }
      })
      .catch((error) => {
        // console.log(error.response);
        if (error.response.status === 400) {
          dispatch(loginFailure(error.response.data.message));
        } else if (error && error.response.status === 401) {
          // initializeToken();
          dispatch(loginFailure(error.response.data.detail));
        } else {
          dispatch(loginFailure(error.response.data.detail));
        }
        return false;
      });
  };
}

export function sendOtpAction() {
  return function action(dispatch) {
    dispatch(otpRequest());

    return apiClient
      .post("/api/sendOtp")
      .then((response) => {
        if (response.data.status === 200) {
          dispatch(otpRequestSuccess(response.data.message));
          return true;
        } else {
          dispatch(otpRequestFailure(response.data.message));
          return false;
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          dispatch(otpRequestFailure("Something went wrong! Retry."));
        }
        return false;
      });
  };
}
